import { Link, type LinkProps } from "@octopus-energy/coral/atoms"

type EmailLinkProps = Omit<LinkProps, "children" | "href"> & {
    email: string
}

export function EmailLink({ email, ...linkProps }: EmailLinkProps) {
    return (
        <Link
            href={`mailto:${email}`}
            {...linkProps}
        >
            {email}
        </Link>
    )
}
